import React, { Component } from 'react';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactPlayerLoader from '@brightcove/react-player-loader';
import { connect } from 'react-redux';
import ReactModalHeader from '../Modal/ReactModalHeader';

const StyledContainer = styled.div`
  .video-js {
    width: 544px;
    height: calc((544px) * 0.5625);
    margin: 16px 48px 16px 48px;

    @media (max-width: 767px) {
      width: calc(100vw - 32px);
      height: calc((100vw - 32px) * 0.5625);
      margin: 16px 16px 16px 16px;
      margin-bottom: 0;
    }

    @media (max-width: 767px) and (orientation: landscape) {
      height: calc(100vh - 80px);
      width: auto;
    }

    .vjs-poster,
    .vjs-tech {
      background-color: ${tokens.ColorWhite000};
    }
  }
`;

class VideoModal extends Component<any> {
  render(): JSX.Element {
    const {
      videoData: { accountId, videoId, playerId },
    } = this.props;
    return (
      <StyledContainer>
        <ReactModalHeader showClose={true} />
        <ReactPlayerLoader accountId={accountId} videoId={videoId} playerId={playerId} />
      </StyledContainer>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    videoData: state.educationContainer.tilesInformation['videoUrlResponse'],
  };
};

export default connect(mapStateToProps, null)(VideoModal);
